import classNames from 'classnames';
import { formatCurrency } from '@wolffun/system-currency';
import React from 'react';
import { useCallout } from '..';
import { CalloutPosition } from '../types';
import styles from './styles.module.scss';
import { useBreakpoint } from 'src/utils/breakpoints';
import { formatDynamicString } from 'src/utils/text';

const CalloutContent = ({
  className,
  children,
  position = CalloutPosition.BOTTOM,
  calloutTab,
  calloutDisabled = false,
  isHamburger,
  color = '#007C1B'
}) => {
  const ref = React.useRef(null);
  const {
    show,
    hide,
    currentCallout,
    listNotification,
    isCalloutDisplayed
  } = useCallout();
  const breakpoint = useBreakpoint();
  const checkLive = React.useCallback(tab => {
    if (calloutTab instanceof Array) {
      return !!tab && calloutTab.includes(tab);
    } else {
      return tab === calloutTab;
    }
  }, [calloutTab]);
  const hasCallout = checkLive(currentCallout === null || currentCallout === void 0 ? void 0 : currentCallout.tabEnum);
  const isLive = React.useMemo(() => {
    return !!(listNotification !== null && listNotification !== void 0 && listNotification.find(checkLive));
  }, [checkLive, listNotification]);
  const renderCallout = React.useCallback(() => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.callout
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.label
    }, currentCallout !== null && currentCallout !== void 0 && currentCallout.reward ? formatDynamicString(currentCallout.callOutMess, formatCurrency(currentCallout.reward, {
      showPlusSign: true,
      trimWholeFraction: true
    })) : currentCallout === null || currentCallout === void 0 ? void 0 : currentCallout.callOutMess));
  }, [currentCallout]);
  const showCallout = React.useCallback(() => {
    var _ref$current;

    const rect = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect();
    rect && show({
      title: renderCallout(),
      position: {
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height
      },
      direction: position,
      color
    });
  }, [color, position, renderCallout, show]);
  React.useEffect(() => {
    if (!calloutDisabled && currentCallout !== null && currentCallout !== void 0 && currentCallout.tabEnum && currentCallout.tabEnum === calloutTab || currentCallout !== null && currentCallout !== void 0 && currentCallout.tabEnum && isHamburger) {
      const timeout = setTimeout(() => {
        showCallout();
      }, 100);
      return () => clearTimeout(timeout);
    }

    return undefined;
  }, [calloutTab, currentCallout === null || currentCallout === void 0 ? void 0 : currentCallout.tabEnum, calloutDisabled, showCallout, isHamburger, hide]); // Calculating and rendering tooltips when the breakpoint has changed

  React.useEffect(() => {
    if (isCalloutDisplayed && (!calloutDisabled && currentCallout !== null && currentCallout !== void 0 && currentCallout.tabEnum && currentCallout.tabEnum === calloutTab || currentCallout !== null && currentCallout !== void 0 && currentCallout.tabEnum && isHamburger)) {
      const timeout = setTimeout(() => {
        showCallout();
      }, 300); // Wait for UI display and then calculate the render position

      return () => {
        clearTimeout(timeout);
      };
    }

    return undefined;
  }, [isCalloutDisplayed, showCallout, breakpoint, calloutDisabled, currentCallout === null || currentCallout === void 0 ? void 0 : currentCallout.tabEnum, calloutTab, isHamburger, hide]);

  const renderContent = () => {
    return /*#__PURE__*/React.createElement("div", {
      ref: ref,
      className: classNames(styles.container, className)
    }, children);
  };

  if (hasCallout) {
    return renderContent();
  }

  if (!isLive && !isHamburger) {
    return null;
  }

  return renderContent();
};

export default CalloutContent;